import { render, staticRenderFns } from "./EndorsementModal.vue?vue&type=template&id=19a00794&scoped=true"
import script from "./EndorsementModal.vue?vue&type=script&lang=js"
export * from "./EndorsementModal.vue?vue&type=script&lang=js"
import style0 from "./EndorsementModal.vue?vue&type=style&index=0&id=19a00794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a00794",
  null
  
)

export default component.exports